export default __webpack_public_path__ + "static/media/typicalweek (5).43fbe7c5.png";